import {
  Database,
  FileText,
  Workflow,
  Link,
  ShieldCheck,
  Cpu,
} from "lucide-react";

export default function KeyFeaturesSection() {
  const features = [
    {
      icon: Database,
      title: "Intelligent Data Extraction",
      desc: "Automatically capture key information from reports, contracts, forms, and claims.",
    },
    {
      icon: FileText,
      title: "Document Classification",
      desc: "Identify and categorize different document types automatically.",
    },
    {
      icon: Workflow,
      title: "Automated Workflows",
      desc: "Trigger business workflows based on extracted document data.",
    },
    {
      icon: Link,
      title: "Seamless Integrations",
      desc: "Export structured data into your existing systems and business tools.",
    },
    {
      icon: Cpu,
      title: "High Accuracy AI Models",
      desc: "Advanced machine learning ensures reliable and scalable document processing.",
    },
    {
      icon: ShieldCheck,
      title: "Secure & Compliant",
      desc: "Enterprise-grade security to protect sensitive business data.",
    },
  ];

  return (
    <div className="w-full py-12 md:py-24" id="key-features">
      <div className="container-width">
        {/* NEGATIVE MARGIN FIX */}
        <div className="-mx-6 md:-mx-12">
          {/* Content */}
          <div className="w-full px-6 md:px-12">
            {/* Heading */}
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-4xl font-semibold mb-2">
                Key Features of Bridge Format AIQ
              </h2>
              <p className="text-gray-600 text-sm md:text-base">
                Powerful AI Document Intelligence
              </p>
            </div>

            {/* Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div
                    key={index}
                    className="bg-gray-100 rounded-[4px] p-8 h-full transition-all duration-300 hover:shadow-xl"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-[4px] bg-gray-300 mb-4">
                      <Icon className="w-5 h-5 text-gray-700" />
                    </div>

                    <h3 className="font-semibold text-base md:text-lg mb-2">
                      {feature.title}
                    </h3>

                    <p className="text-sm md:text-base text-gray-600">
                      {feature.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
